<template>
    
</template>

<script>
    export default {
        name: "wageComparisonColumnsList"
    }
</script>

<style scoped>

</style>
